import {
  DetailPanel,
  DetailPanelGrid,
  type DetailPanelGridProps,
  type DetailPanelProps,
} from '@/components/shared';

export type OrganizationDetailPanelGridProps = DetailPanelGridProps;
export type OrganizationDetailPanelProps = DetailPanelProps;

export const OrganizationDetailPanelGrid = DetailPanelGrid;
export const OrganizationDetailPanel = DetailPanel;
